<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card mb-5">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="card-title mb-0">Salary Summary</h5>
                    </div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-12">
                                <div class="row g-3">
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Basic salary</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.basic_salary, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Total Monthly Allowances</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.total_allowances, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Total Monthly Deductions</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.total_deductions, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Monthly Gross pay</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.gross_pay, 2) }}</h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Taxable Gross</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.taxable_gross, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Monthly Net pay</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.net_pay, 2) }}</h6>
                                    </div>
                                     <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Total Arrears</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.arrears, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Total Refunds</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.refunds, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Total Loans</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.total_loans, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">TAX</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.tax, 2) }}
                                        </h6>
                                    </div>
                                     <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">NHF</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.nhf, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">SHIS</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.shis, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Union Dues</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.union_dues, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Contributions</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.contributions, 2) }}
                                        </h6>
                                    </div>
                                    <div class="col-sm-6 col-md-4">
                                        <label class="small text-muted">Annual Rent</label>
                                        <h6 class="mb-0">{{ $filters.money_format(payroll_data.annual_rent, 2) }}
                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xxl-6">
                        <employee-bank-account :employeeId="employee.id"  />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeBankAccount from './components/EmployeeBankAccount.vue'

export default {
    components: {
        EmployeeBankAccount,
    },
    props: {
        employee: {
            type: Object,
            required: true
        }
    },
    computed: {
        user() {
            return this.employee.user || this.fakeUserModel
        },
        payroll_data() {
            return this.employee.payroll_data
        }
    }
}
</script>

<style></style>